import gql from "graphql-tag";

export const deleteDealerMutation = gql`
  mutation deleteDealer($userId: ID!) {
    deleteDealer(userId: $userId) {
      id
    }
  }
`;
